// extracted by mini-css-extract-plugin
module.exports = {"close":"Modal_close__wNaAk","header":"Modal_header__GTKLh","wrapper":"Modal_wrapper__rZ4vk","content":"Modal_content__Bzy4G","container":"Modal_container__w3LT2"};